import { inject, InjectionToken, Service } from '@angular/core';

export const STORAGE = new InjectionToken<Storage>('Storage API');

@Service()
export class StorageManager {
  private readonly storage = inject(STORAGE);

  get<T>(key: string): T | null {
    const storedValue = this.storage.getItem(key);

    try {
      return storedValue ? JSON.parse(storedValue) : null;
    } catch {
      this.remove(key);
      return null;
    }
  }

  set<T>(key: string, value: NonNullable<T>): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  remove(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}
